import angular from 'angular';
import uiRouter from 'angular-ui-router';
import statesTemplateComponent from './states-template.component';

let statesTemplateModule = angular
  .module('states-template', [uiRouter])
  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newStatesTemplate', {
        url: '/states-templates/new',
        component: 'statesTemplate',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          statesTemplates: StatesTemplatesService =>
            StatesTemplatesService.find()
        }
      })
      .state('editStatesTemplate', {
        url: '/states-templates/:id',
        component: 'statesTemplate',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          statesTemplate: (StatesTemplatesService, $stateParams) =>
            StatesTemplatesService.findById($stateParams.id),
          statesTemplates: StatesTemplatesService =>
            StatesTemplatesService.find()
        }
      });
  })
  .component('statesTemplate', statesTemplateComponent).name;

export default statesTemplateModule;
